import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

const moduleExports = [FilterBarComponent];

@NgModule({
  declarations: [moduleExports],
  exports: [moduleExports],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
})
export class FiltersModule {}
